module.exports = __webpack_public_path__ + "img/arrow-up-left-circle-fill.3b40fa10.svg";